import { Component } from 'src/utils';
import user from './../../../images/user.png';
import logo from './../../../images/small-logo.png';
import back from './../../../images/hamburger.png';
import template from './sidenav.html';

@Component({
  controllerAs: 'sidenav',
  template
})

export default class SidenavContainer {
  static $inject = [
    '$rootScope',
    '$scope',
    '$ngRedux',
    '$state',
    '$location',
    'toaster',
    'authService',
    'orderService',
    '$uibModal',
    '$stateParams',
    'APP',
    '$cookies'
  ];

  constructor($rootScope, $scope, $ngRedux, $state, $location,
    toaster, $auth, $order, $uibModal, $stateParams, APP, $cookies) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$location = $location;
    this.toaster = toaster;
    this.$auth = $auth;
    this.user = user;
    this.logo = logo;
    this.back = back;
    this.$uibModal = $uibModal;
    this.APP = APP;
    this.$stateParams = $stateParams;
    this.$cookies=$cookies;
    this.version_number = APP.AUTH.AUTH_URL.version.num;
    
    let guestStore = null;
    try {
      guestStore = sessionStorage.getItem('guestStoreName');
    }
    catch (e) {
      guestStore = $cookies.get('guestStoreName');
    }
    if(guestStore){
      $order.getGiftCards();
    }
    // $order.getCategories();

    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {

    return {
      profile: state.auth.profile,
      categories: state.order.categories,
      giftCards : state.order.giftCards
    };
  }

  closeSideNav() {
    this.$rootScope.$emit('closeSideNav');
  }
  goToOrders() {

    if (!this.$auth.isLoggedIn()) {
      var msg = 'access this';
      this.$auth.showLoginPopUp(msg);
    }

    else {
      this.$state.go('recent-order');
    }
  }

   goToSubscriptions() {

    if (!this.$auth.isLoggedIn()) {
      var msg = 'access this';
      this.$auth.showLoginPopUp(msg);
    }

    else {
      this.$state.go('subscription');
    }
  }

  

  goToSavingsClub() {
    this.closeSideNav();
    this.$state.go('savings-club', {'storeName': this.$auth.getGuestStoreDetail().storeName});

  }
  goToNextState(item) {
    // console.log(item);
    let storeName = '';
    if(this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    }
    else {
      if(this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
       storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if(storeName) { 
     if (item.category.name === item.subCategoryList[0].name ) {
       this.$state.go('browse-product', {
         categoryId: item.category.prettyUrl,
         subCategoryId: item.subCategoryList[0].prettyUrl,
         storeName: storeName
       });
     }
     else {
      // console.log('sc',item.category.id);
       this.$state.go('browse-sub-category', {categoryId: item.category.prettyUrl,  
         storeName: storeName});
     }
    } 
    else {
     if (item.category.name === item.subCategoryList[0].name ) {
       this.$state.go('browse-product', {
         categoryId: item.category.prettyUrl,
         subCategoryId: item.subCategoryList[0].prettyUrl,
         storeName: 'shop'
       });
     }
     else {
      // console.log('sc',item.category.id);
       this.$state.go('browse-sub-category', {categoryId: item.category.prettyUrl,storeName:'shop'});
     }
   }
   }

  openToast() {
    this.toaster.pop('success', 'This Feature will be available soon');
  }

  logout() {
    this.$auth.logout(this.profile);
  }

  syncedToday() {
    let syncDate = new Date(this.profile.customer.lastSyncDateTime);
    let currentDate = new Date();
    return (syncDate.getDate() === currentDate.getDate());
  }

  isDscMember() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
  }

  isDscButExpired() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
  }

  isLoggedIn() {
    return this.$auth.isLoggedIn();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/sidenav/sidenav.js